jQuery( document ).ready( function ( $ ) {
	/**
	 * Handle the accordion functionality.
	 */
	( function () {
		const activeClass = 'active';

		$( document ).on( 'click', '[class*="__accordion-heading"]', function () {
			const clickedHeading = $( this ),
			      item           = clickedHeading.parent();

			console.log( item );

			item.toggleClass( activeClass );

			if ( item.hasClass( activeClass ) ) {
				clickedHeading.next().slideDown();
				clickedHeading.addClass( activeClass );
			} else {
				clickedHeading.next().slideUp();
				clickedHeading.removeClass( activeClass );
			}

			item.siblings().each( function () {
				$( this ).removeClass( activeClass );
				$( this ).find( '[class*="__accordion-heading"]' ).removeClass( activeClass );
				$( this ).find( '[class*="__accordion-content"]' ).slideUp();
			} );
		} );
	} )();

	( function () {
			function hide_loader() {
				$( '.loading' ).hide();
			}

			function show_loader() {
				$( '.loading' ).show();
			}

			function hide_load_posts() {
				$( '#load_posts' ).hide();
			}

			function show_load_posts() {
				$( '#load_posts' ).show();
			}

			// var scroll_load = new Waypoint( {
			// 	element: document.getElementById( 'blog-load-more' ),
			// 	handler: function ( direction ) {
			// 		if ( direction == 'down' ) {
			// 			$( '#load_posts' ).trigger( 'click' );
			// 		}
			// 	},
			// 	enabled: false,
			// 	offset: 'bottom-in-view'
			// } );

			var update_blog_posts = function ( page = 1, orderby = 'date', replace = true ) {
				if ( replace ) {
					$( '.grid-posts' ).html( '' );
				}
				show_loader();
				hide_load_posts();
				$.ajax(
					{
						url: mt_pomcar_scripts.ajax_url,
						method: 'post',
						data: {
							action: 'get_blog_posts',
							page: page,
							orderby: orderby
						},
						success: function ( result ) {
							if ( result.html ) {
								if ( replace ) {
									$( '.grid-posts' ).html( result.html );
								} else {
									$( '.grid-posts' ).append( result.html );
								}
							}
							hide_loader();
							if ( result.end ) {
								// scroll_load.disable();
							} else {
								show_load_posts();
								// scroll_load.enable();
							}
						}
					}
				);
			}

			// On sort button click.
			$( '.grid-sort button' ).on( 'click', function ( e ) {
				e.preventDefault();

				const non_selected_class = 'btn-outline-dark';
				const selected_class     = 'btn-primary';

				if ( $( this ).hasClass( non_selected_class ) ) {
					var load_more = $( '#load_posts' ),
					    id        = $( this ).attr( 'id' ),
					    orderby   = $( this ).data( 'orderby' );

					// Add/remove classes.
					$( this ).removeClass( non_selected_class ).addClass( selected_class );
					$( '.grid-sort button:not(#' + id + ')' ).removeClass( selected_class ).addClass( non_selected_class );

					// reset load more button atts.
					load_more.data( 'orderby', orderby );
					load_more.data( 'page', 2 );

					// update post grid
					update_blog_posts( 1, orderby, true, true );
				}
			} );

			// On load more button click.
			$( document ).on( 'click', '#load_posts', function ( e ) {
				e.preventDefault();

				var load_more = $( this ),
				    page      = load_more.data( 'page' ),
				    orderby   = load_more.data( 'orderby' );

				// update post grid.
				update_blog_posts( page, orderby, false );

				$( '#load_posts' ).data( 'page', page + 1 );
			} );
		}
	)();

	// Back to top button.
	( function () {
		const backToTop = document.getElementById( "mt-pomcar-back-to-top" );

		window.addEventListener( "scroll", () => {
			if ( window.scrollY > 200 ) {
				backToTop.style.display = "block";
			} else {
				backToTop.style.display = "none";
			}
		} );

		backToTop.addEventListener( "click", ( e ) => {
			e.preventDefault();
			window.scrollTo( { top: 0, behavior: "smooth" } );
		} );
	} )();

} );
